import React from 'react';

import {
  CheckBoxBeforeAns,
  RadioButtonBeforeAns,
  NumberInputBeforeAns,
  TextInputAfterAns,
  TableGroup,
} from '@components/ea/notificationDuty/elements';

import { NTCE_SCREN_DISP_METH_CD } from '@common/constants';

/**
 * 답변 영역
 */
const AnswerArea = props => {
  const {
    isPreUw = false,
    group,
    items,
    prevItems,
    nextItems,
    noticeDutyTooltips,
    setNoticeDutyTooltips,
    tbNbsPolicyBfNtceAnsDtlDTO,
    tbNbsPolicyBfNtceAnsByitmDtlDTO,
    setTbNbsPolicyBfNtceAnsByitmDtlDTO,
    onSave,
  } = props;

  switch (items[items.length - 1].dispGroup) {
    case NTCE_SCREN_DISP_METH_CD.CHECK_BOX: // B1
      return (
        <CheckBoxBeforeAns
          isPreUw={isPreUw}
          group={group}
          items={items}
          prevItems={prevItems}
          noticeDutyTooltips={noticeDutyTooltips}
          setNoticeDutyTooltips={setNoticeDutyTooltips}
          tbNbsPolicyBfNtceAnsDtlDTO={tbNbsPolicyBfNtceAnsDtlDTO}
          tbNbsPolicyBfNtceAnsByitmDtlDTO={tbNbsPolicyBfNtceAnsByitmDtlDTO}
          setTbNbsPolicyBfNtceAnsByitmDtlDTO={
            setTbNbsPolicyBfNtceAnsByitmDtlDTO
          }
          onSave={onSave}
        />
      );
    case NTCE_SCREN_DISP_METH_CD.RADIO_BTN: // B2
      return (
        <RadioButtonBeforeAns
          isPreUw={isPreUw}
          group={group}
          items={items}
          tbNbsPolicyBfNtceAnsDtlDTO={tbNbsPolicyBfNtceAnsDtlDTO}
          tbNbsPolicyBfNtceAnsByitmDtlDTO={tbNbsPolicyBfNtceAnsByitmDtlDTO}
          setTbNbsPolicyBfNtceAnsByitmDtlDTO={
            setTbNbsPolicyBfNtceAnsByitmDtlDTO
          }
          onSave={onSave}
        />
      );
    case NTCE_SCREN_DISP_METH_CD.NUMBER_IPT: // B3
      return (
        <NumberInputBeforeAns
          isPreUw={isPreUw}
          group={group}
          items={items}
          tbNbsPolicyBfNtceAnsDtlDTO={tbNbsPolicyBfNtceAnsDtlDTO}
          tbNbsPolicyBfNtceAnsByitmDtlDTO={tbNbsPolicyBfNtceAnsByitmDtlDTO}
          setTbNbsPolicyBfNtceAnsByitmDtlDTO={
            setTbNbsPolicyBfNtceAnsByitmDtlDTO
          }
          onSave={onSave}
        />
      );
    case NTCE_SCREN_DISP_METH_CD.TEXT_IPT: // A1
      return (
        <TextInputAfterAns
          isPreUw={isPreUw}
          group={group}
          items={items}
          tbNbsPolicyBfNtceAnsDtlDTO={tbNbsPolicyBfNtceAnsDtlDTO}
          tbNbsPolicyBfNtceAnsByitmDtlDTO={tbNbsPolicyBfNtceAnsByitmDtlDTO}
          setTbNbsPolicyBfNtceAnsByitmDtlDTO={
            setTbNbsPolicyBfNtceAnsByitmDtlDTO
          }
          onSave={onSave}
        />
      );
    case 'TABLE_GRP':
      return (
        <TableGroup
          isPreUw={isPreUw}
          group={group}
          items={items}
          tbNbsPolicyBfNtceAnsDtlDTO={tbNbsPolicyBfNtceAnsDtlDTO}
          tbNbsPolicyBfNtceAnsByitmDtlDTO={tbNbsPolicyBfNtceAnsByitmDtlDTO}
          setTbNbsPolicyBfNtceAnsByitmDtlDTO={
            setTbNbsPolicyBfNtceAnsByitmDtlDTO
          }
          onSave={onSave}
        />
      );
  }
};

export default AnswerArea;
